import { encryptData, decryptData } from './encryptation';

export const getItem = (key) => {
  const stored = localStorage.getItem(key);
  if (stored) {
    try {
      return decryptData(JSON.parse(stored));
    } catch {
      return null;
    }
  }
  return null;
};

export const setItem = (key, value) => {
  if (!key || !value) return;
  localStorage.setItem(key, JSON.stringify(encryptData(value)));
};

export const removeItem = (key) => {
  if (!key) return;
  localStorage.removeItem(key);
};

export const setClass = (condition, className) => {
  if (condition) {
    if (!document.body.className.includes(className)) {
      document.body.classList.add(className);
    }
  } else {
    document.body.classList.remove(className);
  }
};
